module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/internals/is-pure.js
// module id = 87
// module chunks = 0